import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as DialogCheck } from "../assets/images/dialog-check.svg";
import { ReactComponent as DialogAlert } from "../assets/images/dialog-alert.svg";
import { ReactComponent as BtnX } from "../assets/images/btnX.svg";
import cssVariables from "../theme/cssVariables";

const AlertDialog = (props) => {
  const { type, title, message, color, open, close, acceptConfirm, colorHover, size } = props;
  const useStyles = makeStyles({
    fill: {
      '& > path': {
        fill: color
      },
      '& g > path': {
        fill: color
      },
    },
    fillBtnx: {
      margin: "5px 12px 0 0",
      '& > path': {
        fill: color
      },
      '& g > path': {
        fill: color
      },
    },
  });
  const classes = useStyles();
  const handleClose = () => {
    close()
  };
  const styles = {
    title: {
      fontSize: "24px",
      lineHeight: "26.4px",
      color: cssVariables.color.primary
    },
    message: {
      fontSize: "16px",
      lineHeight: "26px",
      color: cssVariables.color.black
    },
    successTitle: {
      fontSize: "24px",
      lineHeight: "26.4px",
      color: cssVariables.color.black
    },
    successMessage: {
      fontSize: "18px",
      lineHeight: "24.59px",
      color: cssVariables.color.black
    },
    errorTitle: {
      fontSize: "24px",
      lineHeight: "26.4px",
      color: "#CC6058"
    },
    errorMessage: {
      fontSize: "18px",
      lineHeight: "24.59px",
      color: cssVariables.color.black
    },
  };
  const hoverColor = () => {
    if (colorHover !== null && colorHover !== undefined && colorHover !== "") {
      return colorHover;
    } else {
      return color;
    }
  }
  const customSize = (data) => {
    if (size !== null && size !== undefined && size !== "") {
      return size;
    } else {
      return data;
    }
  }

  const { t } = useTranslation();

  return (
    <React.Fragment>
      {type === "success" ?
         <Dialog
onBackdropClick={() => {return false}}
          open={open}
          onClose={handleClose}
          maxWidth={customSize("xs")}
          fullWidth={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
              <DialogCheck></DialogCheck>
              <Typography variant="h3" mt={3} style={styles.title} dangerouslySetInnerHTML={{ __html: title }}></Typography>
              <Typography textAlign="center" mt={2} dangerouslySetInnerHTML={{ __html: message }} style={styles.message}></Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
            <Button onClick={handleClose} size="large" variant="contained" sx={{ width: '300px' }}>{t('label.close')}</Button>
          </DialogActions>
        </Dialog>
        : type === "confirm" ?
           <Dialog
onBackdropClick={() => {return false}}
            open={open}
            onClose={handleClose}
            maxWidth={customSize("sm")}
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="form-add-dialog-title" fontSize="1.3rem">
              <Typography dangerouslySetInnerHTML={{ __html: title }} style={styles.successTitle}></Typography>
              <Box sx={{ position: "absolute", right: 0, margin: "15px 18px 0  0", top: 0 }} onClick={handleClose}><BtnX className={`${classes.fillBtnx}`} /></Box>
              <Divider sx={{ marginTop: "10px" }} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
                <DialogAlert className={`${classes.fill}`} />
                <Typography mt={3} fontSize={16} dangerouslySetInnerHTML={{ __html: message }} style={styles.successMessage}></Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
              <Button onClick={handleClose} size="medium" variant="outlined" sx={{ width: '150px', marginRight: "10px" }} color="black">{t('label.cancel')}</Button>
              <Button onClick={acceptConfirm} size="medium" variant="contained" sx={{ width: '150px', color: "#fff!important", backgroundColor: color, ":hover": { backgroundColor: hoverColor()}}}>{t('label.confirm')}</Button>
            </DialogActions>
          </Dialog>
          : type === "error" ?
             <Dialog
onBackdropClick={() => {return false}}
              open={open}
              onClose={handleClose}
              maxWidth={customSize("xs")}
              fullWidth={true}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
                  <DialogAlert className={`${classes.fill}`} />
                  <Typography variant="h3" mt={3} style={styles.errorTitle} dangerouslySetInnerHTML={{ __html: title }}></Typography>
                  <Typography textAlign="center" mt={2} dangerouslySetInnerHTML={{ __html: message }} style={styles.message}></Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                <Button onClick={handleClose} size="large" variant="contained" sx={{ width: '300px', backgroundColor: color, ":hover": { backgroundColor: hoverColor()}}}>{t('label.close')}</Button>
              </DialogActions>
            </Dialog>
            : null
      }
    </React.Fragment>
  );
};
export default AlertDialog;
